'use client'

import ChevronDown from '@/components/icons/chevron-down'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import Link from 'next/link'
import { useParams } from 'next/navigation'

const profileOptions = {
  driver: 'Driver Profile',
  livery: 'Livery Designer',
  broadcaster: 'Broadcaster',
  commentator: 'Commentator',
  about: 'About',
}

export default function ProfileSelector({ width = '100%', userProfilePath }) {
  const params = useParams()
  const currentProfileType = params.profileType

  return (
    <div className="mx-4 mt-6 w-[calc(100%-32px)] pb-4 desktop-sm:hidden">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            style={{ width }}
            className="outline-hidden group flex min-h-10 items-center justify-between rounded-[40px] border-0 bg-white px-4 text-left font-inter text-sm font-semibold text-black underline-offset-4 hover:underline focus-visible:ring-2 focus-visible:ring-primary data-[state=open]:rounded-b-none data-[state=open]:rounded-t-lg"
          >
            {profileOptions[currentProfileType]}
            <ChevronDown className="ml-3 h-5 w-5 shrink-0 stroke-slate-800 stroke-2 transition-transform group-data-[state=open]:rotate-180" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          sideOffset={0}
          className="z-50 w-[var(--radix-dropdown-menu-trigger-width)] rounded-b-[9px] rounded-t-none border-neutral-blue-700 bg-white p-0 py-2 text-black shadow-lg dark:bg-white dark:text-black"
        >
          {Object.entries(profileOptions)
            .filter(([profileType]) => profileType !== currentProfileType)
            .map(([profileType, label]) => (
              <DropdownMenuItem
                asChild
                key={profileType}
                className="rounded-none p-0 text-black focus:bg-neutral-blue-50 focus:text-black dark:focus:bg-neutral-blue-50 dark:focus:text-black"
              >
                <Link
                  className="flex min-h-10 w-full items-center whitespace-nowrap px-4 text-left font-inter text-sm font-semibold underline-offset-4 hover:underline"
                  data-istestflow={`${profileType}Button`}
                  href={`${userProfilePath}/${profileType}`}
                >
                  {label}
                </Link>
              </DropdownMenuItem>
            ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
